// FetchHubs.js

export const FetchHubs = async () => {
    // console.log('Fetching hubs...base url:', process.env.REACT_APP_API_URL);
    const request = new Request(`${process.env.REACT_APP_API_URL}/api/hubs`, {
        method: 'GET',
        credentials: 'include', // Ensure cookies are sent with the request
    });
    // console.log('Request hubs:', request);

    try {
        const response = await fetch(request);
        // console.log('Response hubs:', response);

        if (!response.ok) {
            throw new Error(`HTTP error from fetching hubs! Status: ${response.status} ${response.statusText}`);
        }

        const hubs = await response.json();
        console.log('Fetched hubs data:', hubs);


        return hubs;

    } catch (error) {
        console.error('Error fetching hubs data:', error);
        throw error;
    }
};

